import { dateTimeValueFormatter } from 'components/AgGrid/gridComponents/helpers';
import { ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import ProductConfigurationView from './ProductConfigurationView';
import { Box } from '@mui/material';

interface ProductSummaryProps {
  serviceAgreement: ServiceAgreementV2 | null;
}

const ProductSummary = ({ serviceAgreement }: ProductSummaryProps) => {
  const createdAt = serviceAgreement?.createdAt
    ? dateTimeValueFormatter({ value: serviceAgreement?.createdAt?.toISOString() ?? '' })
    : undefined;
  const modifiedAt = serviceAgreement?.modifiedAt
    ? dateTimeValueFormatter({ value: serviceAgreement?.modifiedAt?.toISOString() ?? '' })
    : undefined;
  const closureDate = serviceAgreement?.closureDate
    ? dateTimeValueFormatter({ value: serviceAgreement?.closureDate?.toISOString() ?? '' })
    : undefined;
  const plannedClosureDate = serviceAgreement?.plannedClosureDate
    ? dateTimeValueFormatter({ value: serviceAgreement?.plannedClosureDate?.toISOString() ?? '' })
    : undefined;
  const configurationViewProps = {
    Family: serviceAgreement?.family,
    Category: serviceAgreement?.category,
    'Created by': serviceAgreement?.createdBy,
    'Created at': createdAt,
    'Last Action': modifiedAt,
    'Closure Date': closureDate,
    'Planned Closure Date': plannedClosureDate,
  };

  return (
    <Box data-testid="product-summary">
      <ProductConfigurationView attributes={configurationViewProps} title={''} />
    </Box>
  );
};

export default ProductSummary;
